export default [

     {
          path: '/prevention-measure',
          name: 'PreventionMeasure',
          component: () => import("@/views/Page/PreventionMeasure/PreventionMeasure.vue"),
          meta: {
               title: 'Prevention Measure',
          },
     }
];